<template>
    <div class="image-carousel">
        <span v-if="showArrows" class="image-carousel-button left" @click="scroll('left')" @mouseenter="playStop" @mouseleave="autoPlay">
            <i class="el-icon-arrow-left"></i>
        </span>
        <div class="image-carousel-container" ref="containerRef">
            <div class="image-carousel-item" v-for="(item, index) in data" :key="index"
                :style="{ width: itemWidth + 'px', marginRight: gap + 'px' }" @click="goToDetail(item.id)"
                @mouseenter="playStop" @mouseleave="autoPlay">
                <div class="image-carousel-item-content">
                    <div class="t1">{{ item.title }}</div>
                    <div class="t2">{{ item.sencondTitle }}</div>
                </div>
                <img :src="item.imageUrl" :alt="'img-' + index" />
            </div>
        </div>

        <span v-if="showArrows" class="image-carousel-button right" @click="scroll('right')" @mouseenter="playStop" @mouseleave="autoPlay">
            <i class="el-icon-arrow-right"></i>
        </span>
    </div>
</template>
<script>
import { getSpecList } from '@/api/common'

export default {
    data() {
        return {
            data: [],
            visibleCount: 4,
            itemWidth: 300,
            gap: 15,
            timerRef: null
        }
    },
    methods: {
        async fetchZtList() {
            try {
                const { code, data, message } = await getSpecList();
                if (code != 200) {
                    this.$message.error(message || '获取专题图片出错');
                }
                else {
                    this.data = data;
                    this.$nextTick(() => {
                        this.autoPlay();
                    })
                }
            }
            catch (e) {
                console.error(e);
            }
        },
        scroll(direction) {
            const container = this.$refs.containerRef
            if (!container) return
            const scrollAmount = direction === 'left' ? -(this.itemWidth + this.gap) : this.itemWidth + this.gap
            container.scrollBy({ left: scrollAmount, behavior: 'smooth' })
        },
        autoPlay() {
            if (this.timerRef || this.data.length <= this.visibleCount) return

            const interval = 2000
            this.timerRef = setInterval(() => {
                const container = this.$refs.containerRef
                const { scrollLeft, scrollWidth, clientWidth } = container

                if (scrollLeft + clientWidth + this.gap >= scrollWidth) {
                    container.scrollTo({ left: 0, behavior: 'smooth' })
                    setTimeout(() => this.scroll('right'), interval)
                } else {
                    this.scroll('right')
                }
            }, interval)
        },
        playStop() {
            if (this.timerRef) {
                clearInterval(this.timerRef)
                this.timerRef = null
            }
        },
        goToDetail(id) {
            //this.$router.push({ path: `/spec?id=${id}` });
            window.open(`/spec?id=${id}`);
        }
    },
    computed: {
        showArrows() {
            return this.data.length > this.visibleCount
        }
    },
    mounted() {
        this.fetchZtList();
    },
    beforeDestroy() {
        this.playStop()
    },
}
</script>
<style lang="scss" scoped>
.image-carousel {
  position: relative;
  display: flex;
  align-items: center;
  width: 1280px;
  &-container {
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
  }
  &-button {
    cursor: pointer;
  }
  &-item{
    display: block;
    flex-shrink: 0;
    cursor: pointer;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    
    img{
        display: block;
        width: 100%;
        height: auto;
        aspect-ratio: 1077 / 240;
        object-fit: cover;
        border-radius: 8px;
    }
    
    &-content{
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 16px 12px 12px;
      display: flex;
      flex-direction: column;
      gap: 3px;
      
      .t1{
        font-size: 14px;
        font-weight: 700;
        color: #1a1a1a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 0.5px;
        text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
      }
      
      .t2{
        font-size: 11px;
        font-weight: 400;
        color: #555;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
      }
    }
  }
}

</style>